
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaipunepickupdrop() {



    const cardData =
    {
        keyword: 'Mumbai to Pune Pickup & Drop Taxi ',
        heading: 'S9 Travels: Mumbai to Pune Pickup & Drop Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services for Mumbai to Pune pickup and drop. Whether you are traveling for business, leisure, or simply need a reliable ride between these two cities, our professional drivers and well-maintained fleet ensure a smooth, hassle-free journey. The distance from Mumbai to Pune is approximately 150 km, and the trip typically takes 3 to 4 hours by road, depending on traffic conditions. Enjoy a comfortable and safe ride with our customer-centric service.',

        top: 'Top Places to Explore in Mumbai & Pune with S9 Travels:',

        "topPlaces": [
    {
      "title": "Gateway of India (Mumbai)",
      "description": "A symbol of Mumbai's colonial past, the Gateway of India is a historic monument located by the sea. It’s a must-visit for any traveler exploring Mumbai."
    },
    {
      "title": "Marine Drive (Mumbai)",
      "description": "Marine Drive is a beautiful coastal road in Mumbai, known for its stunning views, particularly at sunset. It's often referred to as the 'Queen’s Necklace.'"
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (Mumbai)",
      "description": "A UNESCO World Heritage Site, this Victorian Gothic railway station is a striking piece of architecture and an important landmark in Mumbai."
    },
    {
      "title": "Koregaon Park (Pune)",
      "description": "Koregaon Park is a well-known locality in Pune, famous for its lush greenery, cafes, and boutique shopping, making it a great spot to relax."
    },
    {
      "title": "Shaniwar Wada (Pune)",
      "description": "A historical fortification in the heart of Pune, Shaniwar Wada is an iconic site that offers insight into the grandeur of the Maratha empire."
    },
    {
      "title": "Aga Khan Palace (Pune)",
      "description": "A historical palace built during the British era, Aga Khan Palace is a significant site for those interested in India's independence history."
    },
    {
      "title": "Sinhagad Fort (Pune)",
      "description": "A historical hill fort located around 30 km from Pune, Sinhagad Fort offers beautiful trekking routes and panoramic views of the surrounding hills."
    },
    {
      "title": "Osho Ashram (Pune)",
      "description": "Known for its spiritual significance, Osho Ashram in Koregaon Park attracts visitors looking for peace, meditation, and a serene atmosphere."
    },
    {
      "title": "Junnar (Pune)",
      "description": "Known for its ancient caves and historical sites, Junnar is a quaint town with temples and forts, providing a glimpse into Maharashtra's rich history."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pune)",
      "description": "A beautiful Japanese garden located in Pune, this garden offers a tranquil escape with its well-maintained paths, ponds, and lush landscapes."
    }
  ],

"services": [
  {
    "name": "Mumbai to Pune Pickup",
    "description": "S9 Travels offers reliable and comfortable pickup services for your journey from Mumbai to Pune. Whether you’re traveling for business or leisure, enjoy a smooth ride with our professional drivers. Book your Mumbai to Pune pickup today!"
  },
  {
    "name": "Mumbai to Pune Drop Taxi",
    "description": "Choose S9 Travels for a hassle-free drop taxi service from Mumbai to Pune. Our comfortable and well-maintained vehicles ensure that you arrive at your destination safely and on time. Book your drop taxi now for a stress-free ride!"
  },
  {
    "name": "Pune to Mumbai Pickup Drop",
    "description": "S9 Travels provides convenient pickup and drop services for your journey between Pune and Mumbai. Whether you need a pickup from Pune and a drop in Mumbai or vice versa, we offer comfortable and reliable options for a seamless trip."
  },
  {
    "name": "Pune to Mumbai Drop Service",
    "description": "For a reliable drop service, S9 Travels offers a comfortable and efficient taxi ride from Pune to Mumbai. Travel in style and comfort with our professional drivers and well-maintained vehicles."
  },
  {
    "name": "Mumbai Pune Taxi Booking",
    "description": "Booking a taxi for your journey between Mumbai and Pune is easy with S9 Travels. Whether you prefer booking online or by phone, we provide flexible booking options tailored to your schedule. Book your Mumbai Pune taxi today!"
  },
  {
    "name": "Mumbai Pune One-Way Taxi",
    "description": "S9 Travels offers affordable one-way taxi services from Mumbai to Pune or vice versa. Whether you’re traveling one way for business or leisure, enjoy a convenient and stress-free ride with our professional drivers."
  },
  {
    "name": "Mumbai Pune Private Cab",
    "description": "For a personalized and private experience, choose S9 Travels for your Mumbai to Pune or Pune to Mumbai journey. Travel at your own pace in a comfortable, well-maintained private cab with a professional driver."
  },
  {
    "name": "Mumbai Pune Efficient Taxi",
    "description": "S9 Travels offers Efficient Taxi services for a budget-friendly travel option. Share the ride with other passengers and enjoy the convenience of a Efficient journey between Mumbai and Pune at an affordable price."
  },
  {
    "name": "Affordable Mumbai Pune Cab",
    "description": "Looking for an affordable yet reliable taxi service? S9 Travels provides comfortable and cost-effective taxi services for your Mumbai to Pune or Pune to Mumbai journey. We guarantee great value with no hidden charges."
  },
  {
    "name": "Pune Mumbai One-Way Car Rental",
    "description": "Rent a car for your one-way journey from Pune to Mumbai or Mumbai to Pune. S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that suit your preferences and needs."
  },
  {
    "name": "Mumbai Pune Efficient Ride",
    "description": "If you're looking to save on your trip between Mumbai and Pune, opt for S9 Travels’ Efficient  ride service. Share the ride with other passengers and enjoy a convenient, comfortable, and affordable journey."
  },
  {
    "name": "Pune to Mumbai Taxi Fare",
    "description": "S9 Travels offers transparent and competitive taxi fares for your journey from Pune to Mumbai. Get great value without any hidden charges. Contact us for an accurate fare estimate for your trip."
  },
  {
    "name": "Luxury Taxi from Mumbai to Pune",
    "description": "For a premium travel experience, S9 Travels offers luxury taxi services from Mumbai to Pune. Enjoy a smooth and comfortable ride with extra space, enhanced comfort, and professional service."
  },
  {
    "name": "Book Pune to Mumbai Taxi",
    "description": "Booking a taxi from Pune to Mumbai is easy with S9 Travels. Whether you’re traveling for business or leisure, we ensure a smooth, comfortable, and reliable journey. Book your Pune to Mumbai taxi today!"
  },
  {
    "name": "Pune Mumbai Cab Booking",
    "description": "S9 Travels makes booking a cab for your Pune to Mumbai journey simple and convenient. Choose from flexible booking options, and enjoy a comfortable and reliable ride with professional drivers. Book your cab today!"
  }
],


"tableData": [
  ["Mumbai To Pune Pickup", "Mumbai To Pune Drop Taxi"],
  ["Pune To Mumbai Pickup Drop", "Pune To Mumbai Drop Service"],
  ["Mumbai Pune Taxi Booking", "Mumbai Pune One-Way Taxi"],
  ["Mumbai Pune Private Cab", "Mumbai Pune Efficient Taxi"],
  ["Affordable Mumbai Pune Cab", "Pune Mumbai One-Way Car Rental"],
  ["Mumbai Pune Efficient Ride", "Pune to Mumbai Taxi Fare"],
  ["Luxury Taxi from Mumbai to Pune", "Book Pune to Mumbai Taxi"],
  ["Pune Mumbai Cab Booking", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important it is to be punctual when traveling between Mumbai and Pune. Whether you're heading for a business meeting, a family trip, or any other reason, our drivers ensure timely pickups and drop-offs, providing a hassle-free experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of comfortable vehicles for your Mumbai to Pune pickup and drop. From sedans to SUVs, all of our vehicles are air-conditioned, spacious, and well-maintained, ensuring a relaxing and enjoyable ride between the two cities."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and professional, familiar with the best routes between Mumbai and Pune. They are committed to providing you with a smooth, safe, and comfortable journey, offering courteous and reliable service throughout your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Mumbai to Pune trip. There are no hidden charges, and we provide a detailed breakdown of the costs upfront, so you know exactly what to expect."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking, ensuring you have a secure and comfortable journey."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates round-the-clock, offering flexibility for both early morning and late-night pickups or drop-offs. Our customer service team is available 24/7 to assist you with any queries or special requirements."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Mumbai to Pune pickup and drop cab with S9 Travels is quick and simple. You can easily book online via our website or mobile app, or you can call our customer service team for personalized assistance with your reservation."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your Mumbai to Pune trip, whether it's for a business visit, sightseeing, or a personal journey. Let us know your preferences, and we will tailor the trip to suit your needs."
  }
]




















    }



    const faqData = [
        [
          {
            question: 'How can I book a Mumbai to Pune pickup and drop with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or you can contact our customer service team for personalized assistance.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and know the best routes between Mumbai and Pune, ensuring a smooth and safe journey.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Pune pickup and drop travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained and designed for comfort during your trip.',
          },
          {
            question: 'How do I pay for my Mumbai to Pune pickup and drop cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, making the payment process convenient and easy.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Pune pickup and drop?',
            answer: 'Yes, we can arrange a round trip. Simply provide us with your return details, and we will take care of the rest.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting or detours will be communicated to you upfront, ensuring transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Pune or Mumbai during my pickup and drop trip?',
            answer: 'Yes, we offer sightseeing services in both Mumbai and Pune. Explore popular landmarks such as Gateway of India, Marine Drive, Shaniwar Wada, and more, with our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Mumbai to Pune pickup and drop cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Mumbai and Pune?',
            answer: 'Yes, we offer corporate travel services, including business trips, group travel, and meetings, between Mumbai and Pune. We ensure punctual and professional service for all corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Mumbai to Pune pickup and drop?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. You can rely on us for a smooth and stress-free ride between Mumbai and Pune.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I had to travel from Mumbai to Pune for a meeting, and S9 Travels made the trip seamless. The driver was punctual, the car was clean, and the service was excellent. Highly recommend!”',
        },
        {
          name: 'Mrs. Neha Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I used S9 Travels for a family trip from Mumbai to Pune. The vehicle was spacious and comfortable, and the driver was very professional. The journey was smooth and enjoyable!”',
        },
      ];
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Mumbai Pune Pickup Drop",
      "description": "Book Mumbai to Pune pickup and drop taxi services, one-way taxi, private cab, Efficient Taxi, and car rental with S9 Travels. Enjoy affordable and comfortable rides for Mumbai to Pune taxi booking with flexible options like one-way and round trips.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.8",
        "ratingCount": "8569"
      }
    };
    
    
    
   
      
      
      


    return (
        <div>
         <Helmet>
      <title>Mumbai Pune Pickup Drop | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
      <meta 
        name="description" 
        content="Book Mumbai to Pune pickup and drop taxi services, one-way taxi, private cab, Efficient Taxi, and car rental with S9 Travels. Get the best fares for Mumbai Pune taxi booking, ensuring a comfortable and safe ride between Mumbai and Pune." 
      />
      
      {/* Inject JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
    
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaipunepickupdrop;